import React from "react";
import Index from "./Index";
import DynamicTitle from "./seo/DynamicTitle";

const PageNotFound = () => {
  return (
    <>
      <DynamicTitle title="404 Page not found" />
      <div className="error-page-wrapper">
        <div className="error-card">
          <div className="error-logo-container">
            <img src={Index.Png.Logo} className="error-logo-img" alt="Logo" />
          </div>

          <div className="error-gfx-container">
            <h1 className="error-gfx-number">404</h1>
          </div>

          <h2 className="error-card-title">Oops! Page Not Found</h2>
          
          <p className="error-card-desc">
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable. Let's get you back on track.
          </p>

          <div className="error-btn-action">
            <Index.Button
              onClick={() => (window.location.href = "/")}
            >
              Back to Dashboard
            </Index.Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
